import { api_url } from './config'

const PLACEHOLDER_IMAGE = '/images/placeholder-product.svg'

const joinUrl = (base, path) => {
  const cleanBase = String(base || '').replace(/\/+$/, '')
  const cleanPath = String(path || '').replace(/^\/+/, '')
  return cleanBase && cleanPath ? `${cleanBase}/${cleanPath}` : cleanPath ? `/${cleanPath}` : ''
}

export const resolveImageUrl = (image, fallback = PLACEHOLDER_IMAGE) => {
  if (!image) return fallback

  const value = typeof image === 'object' && image.url ? image.url : image
  if (typeof value !== 'string') return fallback

  const trimmed = value.trim()
  if (!trimmed) return fallback

  if (/^https?:\/\//i.test(trimmed)) return trimmed
  if (trimmed.startsWith('/uploads')) return joinUrl(api_url, trimmed)
  if (trimmed.startsWith('uploads/')) return joinUrl(api_url, trimmed)
  if (trimmed.startsWith('/')) return trimmed

  return trimmed
}

export const productImage = (product, fallback = PLACEHOLDER_IMAGE) => {
  return resolveImageUrl(product?.thumbnail || product?.images?.[0], fallback)
}

export { PLACEHOLDER_IMAGE }
